import { MappingItem } from '../../GTM'
import { getMapProductDetails } from '../functions/getMapProductDetails'
import { getCategoryName } from '../functions/getCategoryName'

export const plpData = (
    productDetails = getMapProductDetails(),
    categoryName = getCategoryName
): MappingItem => {
    return {
        items: ['products', 'items'],
        categoryName: categoryName,
        pageSize: ['pageSize'],
        currencyCode: [
            [
                'products',
                'items',
                '0',
                'price_range',
                'minimum_price',
                'final_price',
                'currency'
            ],
            [
                'category',
                'products',
                'items',
                '0',
                'price_range',
                'minimum_price',
                'final_price',
                'currency'
            ]
        ],
        currentPage: ['currentPage'],
        productsDetails: productDetails
    }
}
